/* eslint-disable max-lines-per-function */
import { store } from "jiffy-store";
import "./order-line-item.scss";
import "./order-line-item-features/order-line-item-features";
import { track } from "jiffy-analytics";
import { on as onEvent } from "common/utils/ui/event";
import { trackModalOpen } from "components/jiffy/buy-it-again-modal/buy-it-again-modal-track";
import buyItAgainDtfModal from "components/jiffy/buy-it-again-dtf-modal/buy-it-again-dtf-modal";
import { writeCookie } from "common/utils/cookie";
import { redirectTo } from "common/utils/browser";

const sendMixpanelEvent = $button => {
  const {
    brand,
    category,
    composition,
    compositionId,
    favorite,
    fulfillmentGroup,
    product,
    quantity,
    sku
  } = $button.dataset;

  track("buy_it_again", {
    product,
    brand,
    product_category: category,
    spree_composition_id: compositionId,
    fulfillment_group: fulfillmentGroup || "",
    composition,
    quantity,
    sku,
    favorite
  });
};

const sendDtfMixpanelEvent = $button => {
  const { artworkId, catalogNumber } = $button.dataset;

  track("dtf_buy_it_again", { artworkId, catalogNumber });
};

// Inits
const initAddToCartAgain = () => {
  const $forms = document.querySelectorAll(".js-add-to-cart-button-again");

  $forms.forEach($form => {
    $form.addEventListener("submit", () => {
      const $button = $form.querySelector("button");
      $form.classList.add("is-loading");
      sendMixpanelEvent($button);
    });
  });
};

const initDtfAddToCartAgain = () => {
  const $buttons = document.querySelectorAll(".js-dtf-buy-it-again");

  $buttons.forEach($button => {
    $button.addEventListener("click", event => {
      event.preventDefault();
      const { artworkId } = $button.dataset;
      if (artworkId) {
        writeCookie("uploaded_artwork_ids", JSON.stringify([artworkId]), 300);
      }
      sendDtfMixpanelEvent($button);
      redirectTo($button.href);
    });
  });
};
const initDtfAddToCartAgainInline = () => {
  const modal = buyItAgainDtfModal();
  const eventCallback = (event, $button) => {
    const {
      artworkId,
      variantId,
      dtfPrintId,
      productUrl,
      preview,
      productName,
      catalogNumber,
      width,
      height,
      widthValue,
      heightValue,
      enhancementTier,
      preCut,
      isDtfGang,
      brandUrl,
      brandLogo,
      lineItemId,
      lineItemSlug,
      favorite
    } = $button.dataset;
    event.preventDefault();
    modal.openModal({
      dtfArtworkId: artworkId ? parseInt(artworkId, 10) : null,
      variantId,
      dtfPrintId,
      productUrl,
      preview,
      productName,
      catalogNumber,
      width,
      height,
      widthValue: parseFloat(widthValue),
      heightValue: parseFloat(heightValue),
      enhancementTier,
      preCut,
      isDtfGang: isDtfGang === "true",
      brandUrl,
      brandLogo,
      lineItemId,
      lineItemSlug,
      favorite: JSON.parse(favorite)
    });
  };
  onEvent("click", ".js-dtf-buy-it-again-inline", eventCallback);
};

const initBuyItAgainToggle = () => {
  const eventCallback = ({ target }) => {
    const { lineItemId, lineItemComposition } = target.closest("button").dataset;
    const props = {
      productId: parseInt(lineItemId, 10),
      ac: lineItemComposition
    };
    store.cart.change({ buyAgain: props });
    trackModalOpen(props);
  };
  onEvent("click", ".js-buy-it-again-orders-modal-toggle", eventCallback);
};

export default () => {
  initAddToCartAgain();
  initBuyItAgainToggle();
  initDtfAddToCartAgain();
  initDtfAddToCartAgainInline();
};
